import { updateCheckResultSchema, type UpdateCheckResult } from '@secretario/shared';
import { apiFetch } from './api/http.js';
import { nativeBridge } from './secretarioNative.js';
import { isNativeShell } from './platform.js';

const LAST_KEY = 'secretario.atualizacao.conferida';
/** Confere no máximo a cada 6 horas (abrir e fechar o app não vira consulta). */
const EVERY_MS = 6 * 60 * 60 * 1000;

/** Versão instalada (versionCode no Android), lida do próprio pacote. */
async function installedCode(): Promise<number | null> {
  try {
    const { App } = await import('@capacitor/app');
    const info = await App.getInfo();
    const code = Number(info.build);
    return Number.isSafeInteger(code) && code > 0 ? code : null;
  } catch {
    return null;
  }
}

/**
 * Ao abrir o app: conta ao servidor a versão instalada e o que a Play diz que já
 * existe. Com versão nova, o Secretário posta o aviso na conversa fixa e devolve
 * `posted` para o app mostrar o toque "tem novidade".
 */
export async function checkAppUpdate(force = false): Promise<UpdateCheckResult | null> {
  if (!isNativeShell()) return null;
  try {
    const last = Number(window.localStorage.getItem(LAST_KEY) ?? 0);
    if (!force && Date.now() - last < EVERY_MS) return null;
    window.localStorage.setItem(LAST_KEY, String(Date.now()));
  } catch {
    /* sem armazenamento: confere a cada abertura */
  }
  const installed = await installedCode();
  if (!installed) return null;
  const store = await nativeBridge.checkUpdate();
  try {
    return updateCheckResultSchema.parse(
      await apiFetch<unknown>('/v1/app/update-check', {
        method: 'POST',
        body: {
          platform: 'android',
          installedCode: installed,
          availableCode: store?.available ? store.versionCode : null,
        },
      }),
    );
  } catch {
    return null;
  }
}
